// assets
import { IconCode, IconCreditCard, IconLink, IconReceipt, IconRefresh } from "@tabler/icons";

// constant
const icons = {
  IconCreditCard,
  IconRefresh,
  IconReceipt,
  IconCode,
  IconLink,
};

// ==============================|| PAGOS AKUA MENU ITEMS ||============================== //

const pagos = {
  id: "pagos",
  title: "Pagos",
  type: "group",
  children: [
    {
      id: "pagos-akua",
      title: "Pagos",
      type: "collapse",
      icon: icons.IconCreditCard,
      children: [
        {
          id: "lista-pagos",
          title: "Ver Pagos",
          type: "item",
          icon: icons.IconReceipt,
          url: "/pagos/lista",
        },
        {
          id: "generar-link",
          title: "Generar Link de Pago",
          type: "item",
          icon: icons.IconLink,
          url: "/pagos/lista?openCreateLink=true",
        },
      ],
    },
  ],
};

export default pagos;
